export default "__VITE_ASSET__3eaebf24__"